import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Confetti from "react-confetti";
import { useWindowSize } from "react-use";
import { ClaimButton } from "./claimbutton";
import {
  CategoriesTab,
  Category,
  getRandomizedTabs,
  getRandomizedTraits,
} from "./MainAvatar";
import {
  UpdateUserTraits,
  UploadUserTraits,
  useGetAllReferral,
} from "./hooks/helper";
import { useNavigate } from "react-router-dom";

const TABS_KEY = "ts-avatar-tabs";

interface Props {
  onClose: () => void;
}

const WonRewardModal: React.FC<Props> = ({ onClose }) => {
  const { width, height } = useWindowSize();

  const { data, refetch } = useGetAllReferral();
  const navigate = useNavigate();
  const userdetails = data?.user ?? null;
  const [isLoading, setIsLoading] = useState(false);
  const [hasClaimed, setHasClaimed] = useState<boolean>(() => {
    return localStorage.getItem("hasClaimedReward") === "true";
  });
  const [newFlags, setNewFlags] = useState<Record<string, boolean>>({});
  const [tabs, setTabs] = useState<Category[]>(() => {
    if (!userdetails?.traits || userdetails.traits.length === 0) {
      return getRandomizedTabs();
    }
    return CategoriesTab;
  });

  const hasItems = tabs.some(
    (tab) => tab.availableItem && tab.availableItem.length > 0
  );

  const handleClaims = () => {
    const randomized = getRandomizedTraits();
    const formattedTabs = randomized
      .map((tab) => ({
        label: tab.label,
        availableItem: tab.availableItem?.[0] || null,
      }))
      .filter((tab) => tab.availableItem !== null);
    console.log(formattedTabs);
    UpdateUserTraits(formattedTabs);
    setTabs(randomized);
    const updatedFlags: Record<string, boolean> = {};
    formattedTabs.forEach((tab) => {
      updatedFlags[tab.label] = true;
    });
    setNewFlags(updatedFlags);
    navigate("/avatar", { state: { newFlags: updatedFlags } }); // ← Critical fix
    setTimeout(() => {
      setNewFlags({});
    }, 90000);
  };

  const [previewTrait, setPreviewTrait] = useState<{
    label: string;
    item: string;
  } | null>(null);

  const handleClaim = async () => {
    if (isLoading) return;
    setIsLoading(true);

    const randomized = getRandomizedTraits();

    const formattedTabs = randomized
      .map((tab) => ({
        label: tab.label,
        availableItem: tab.availableItem?.[0] || null,
      }))
      .filter((tab) => tab.availableItem !== null);

    UpdateUserTraits(formattedTabs);
    setTabs(randomized);

    const preview = formattedTabs.find(
      (tab) => tab.label.toLowerCase() !== "body"
    );
    if (preview && preview.availableItem) {
      const label = preview.label.toLowerCase();
      const match = preview.availableItem.match(/\d+/);
      const number = match ? match[0] : "1";
      const previewTraitObj = {
        label,
        item: `${label}-${number}`,
      };
      setPreviewTrait(previewTraitObj);
    }

    const updatedFlags: Record<string, boolean> = {};
    formattedTabs.forEach((tab) => {
      if (tab.label.toLowerCase() !== "body") {
        updatedFlags[tab.label] = true;
      }
    });
    setNewFlags(updatedFlags);

    try {
      await refetch();
      localStorage.setItem("hasClaimedReward", "true");
      setHasClaimed(true);
    } catch (err) {
      console.error("Refetch failed:", err);
    }

    setTimeout(() => {
      if (window.location.pathname === "/avatar") {
        onClose();
      } else {
        navigate("/avatar", { state: { newFlags: updatedFlags } });
      }
      onClose();
      navigate("/avatar", { state: { newFlags: updatedFlags } });
      setNewFlags({});
      setIsLoading(false);
    }, 4000);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center">
      {/* Close Button on Top */}
      <button
        onClick={onClose}
        className="absolute top-6 right-6 z-50 text-white text-3xl bg-gray-800 bg-opacity-70 px-4 py-2 rounded-full hover:bg-opacity-100 transition"
      >
        ✕
      </button>
      <Confetti
        width={width}
        height={height}
        numberOfPieces={1500}
        gravity={0.3}
        wind={0.01}
        recycle={false}
      />

      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="z-30 rounded-xl p-6 relative flex flex-col items-center shadow-2xl"
      >
        <motion.img
          src={
            previewTrait
              ? `/assets/main_v4/lootbox/compose/${previewTrait.label.toLowerCase()}/${previewTrait.item.toLowerCase()}.png`
              : "/assets/main_v4/Framebox.png"
          }
          alt="Reward"
          className="w-70 h-72 rounded-xl object-contain border border-white/20 shadow-xl"
          initial={{ scale: 0, rotate: 20, opacity: 0 }}
          animate={{ scale: 1, rotate: 0, opacity: 1 }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 15,
            delay: 0.2,
          }}
        />

        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          {/* {userdetails &&
            (userdetails.traits && userdetails.pfp ? (
              <button
                onClick={() => navigate("/lootbot")}
                className="mt-6 bg-[#9264F8] w-[177px] text-white py-2 text-[15px] rounded-full shadow-lg hover:bg-[#9264F6]"
              >
                Continue
              </button>
            ) : (
              <button
                onClick={handleClaim}
                className="mt-6 bg-[#9264F8] w-[177px] text-white text-[15px] py-2 rounded-full shadow-lg hover:bg-[#9264F6]"
              >
                Claim Now
              </button>
            ))} */}

          <button
            onClick={handleClaim}
            disabled={isLoading || hasClaimed}
            className={`mt-6 w-[177px] text-white text-[15px] py-2 rounded-full shadow-lg ${
              isLoading || hasClaimed
                ? "bg-gray-500 cursor-not-allowed"
                : "bg-[#9264F8] hover:bg-[#9264F6]"
            }`}
          >
            {isLoading
              ? "Claiming..."
              : hasClaimed
              ? "Already Claimed"
              : "Claim Now"}
          </button>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default WonRewardModal;
